import { useEffect, useRef, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { PublicHeader } from "@/components/PublicChrome";
import LoginForm from "@/components/LoginForm";
import { api } from "@/lib/api";
import { useAuth } from "@/lib/auth";
import { keepNext, landingFor } from "@/pages/AuthGoogle";

export default function Verify() {
  const [params] = useSearchParams();
  const [state, setState] = useState("checking");
  const started = useRef(false);
  const navigate = useNavigate();
  const { refresh } = useAuth();

  useEffect(() => {
    if (started.current) return;
    started.current = true;
    const token = params.get("token");
    const el = new URLSearchParams(window.location.hash.slice(1)).get("el");
    if (el) {
      window.history.replaceState(null, "", window.location.pathname);
      api
        .post("/auth/email-login", { token: el })
        .then(async (r) => {
          await refresh();
          navigate(r.data.next || "/app", { replace: true });
        })
        .catch((e) => {
          keepNext(e?.response?.data?.detail?.next || "/app");
          setState("expired_el");
        });
      return;
    }
    if (!token) {
      setState("expired");
      return;
    }
    api
      .post("/auth/verify", { token })
      .then(async () => {
        const u = await refresh();
        navigate(landingFor(u), { replace: true });
      })
      .catch(() => setState("expired"));
  }, [params, navigate, refresh]);

  return (
    <div className="min-h-dvh bg-bg">
      <PublicHeader onLogin={() => {}} />
      <main className="mx-auto max-w-[440px] px-5 pt-16">
        {state === "checking" && (
          <p data-testid="verify-checking" className="text-[15px] text-muted">
            Connexion en cours...
          </p>
        )}
        {state === "expired_el" && (
          <div className="fade-up" data-testid="verify-el-expired">
            <h1 className="text-2xl font-semibold tracking-[-0.02em] text-ink" data-testid="verify-el-expired-title">
              Ce lien a expiré. Connecte-toi pour continuer.
            </h1>
            <div className="mt-6">
              <LoginForm submitLabel="Recevoir un lien de connexion" testPrefix="el-login" />
            </div>
          </div>
        )}
        {state === "expired" && (
          <div className="fade-up" data-testid="verify-expired">
            <h1 className="text-2xl font-semibold tracking-[-0.02em] text-ink" data-testid="verify-expired-title">
              Ce lien a expiré. Demande-en un nouveau.
            </h1>
            <div className="mt-6">
              <LoginForm submitLabel="Recevoir un nouveau lien" testPrefix="resend" />
            </div>
          </div>
        )}
      </main>
    </div>
  );
}
